module.exports = __webpack_public_path__ + "static/media/to-do-list.c9ca3ceb.png";